import { Middleware, MiddlewareAPI } from 'redux';
import * as logger from 'logger';
import {
  AcceptTermsAction,
  DeclineTermsAction,
  TermsAcceptedAction,
  UpdateUserTermsAcceptanceAction,
  ACCEPT_TERMS,
  DECLINE_TERMS,
  UPDATE_USER_TERMS_ACCEPTANCE,
  TermsIgnoredAction
} from './actions';
import { LoginErrorAction } from 'pages/login/actions';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import { AppState } from 'pages/app/state';
import * as userService from 'services/user-service';
import { isOptelTermsId, isNmvsTermsId, isOptelTermsAccepted } from './selectors';
import { acceptTerms as acceptTermsAPI } from 'api/terms-of-use-api';
import { usernameSelector } from 'pages/user-profile/selectors';

const TermsMiddleware: Middleware = store => next => async action => {

  try {
    switch (action.type) {

      case ACCEPT_TERMS:
        await acceptTerms(store, action);
        break;

      case DECLINE_TERMS:
        await declineTerms(store);
        break;

      case UPDATE_USER_TERMS_ACCEPTANCE:
        await updateUserTermsAcceptance(store);
        break;

      default:
        break;
    }
    next(JSON.parse(JSON.stringify(action)));
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'TermsMiddleware');
  }
};

async function acceptTerms(store: MiddlewareAPI, action: AcceptTermsAction) {
  try {
    const state = store.getState();

    // Audit log will be written server side
    if (isNmvsTermsId(state, action.id)) {
      acceptTermsAPI('nmvsTermsOfUseVersion', action.id, action.username);
    } else if (isOptelTermsId(state, action.id)) {
      await acceptTermsAPI('optelTermsOfUseId', action.id, action.username);
    }

    store.dispatch(new TermsAcceptedAction(action.id));
    store.dispatch(new UpdateUserTermsAcceptanceAction());
  } catch (e) {
    const error = e as Error;
    logger.error(error, 'TermsMiddleware.status');
    store.dispatch(new DeclineTermsAction(action.id, action.title, action.username));
  }
}

function declineTerms(store: MiddlewareAPI) {
  const i18n = getI18n();
  const state = store.getState() as AppState;
  // if Optel ToU declined then logout
  if (!isOptelTermsAccepted(state)) {
    store.dispatch(new LoginErrorAction(i18n.t(translations.MustAcceptTermsToLogin)));
  } else {
    // if NMVS ToU declined, then allow them to login
    // every time the token is refreshed - terms will pop again though
    store.dispatch(new TermsIgnoredAction());
  }
}

async function updateUserTermsAcceptance(store: MiddlewareAPI): Promise<void> {
  const state = store.getState() as AppState;
  const user = await userService.getUser(usernameSelector(state));
  user.termsAccepted = isOptelTermsAccepted(state);
  await userService.saveUser(user);
}

export default TermsMiddleware;


// WEBPACK FOOTER //
// ./src/pages/terms-of-use/middleware.ts